export default {
  name: 'Editor',
  path: '/',
  meta: {
    title: 'T4-Editor'
  }
};
